import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {EditorsComponent} from '@irb/irb-editors/irb-editors.com';
import {
    IPortfolioResultOrderTotal,
    IPortfolioResultResponse
} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {AppService} from '@irb/app.service';
import {IrbClientsEvents} from '@irb/irb-clients/irb-clients.events';
import {IrbModelsEvents} from '@irb/irb-models/irb-models.events';
import {IrbRebalanceEvents} from '@irb/irb-rebalance/irb-rebalance.events';
import {ActivatedRoute, Router} from '@angular/router';
import { PrOrdersService } from '../services';

@Component({ standalone: false,
    selector: 'irb-com-pr-summary',
    templateUrl: './com-pr-summary.component.html',
    styleUrls: ['./com-pr-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrSummaryComponent implements EditorsComponent<IPortfolioResultResponse> {
    _data: IPortfolioResultResponse;
    ordersSummary: Array<IPortfolioResultOrderTotal> = [];
    taxInfoSummary: Array<IPortfolioResultOrderTotal> = [];
    @Output() change = new EventEmitter<boolean>();
    isGainThresholdFeatureFlagEnabled: boolean = false;

    constructor(
        private as: AppService,
        private pros: PrOrdersService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.isGainThresholdFeatureFlagEnabled = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_GAINS_THRESHOLD || false;
    }

    onInputChange() {
        this.data.tradeExplanationEdited = true;
        this.change.emit(true);
    }

    @Input()
    get data(): IPortfolioResultResponse {
        return this._data;
    }

    set data(d: IPortfolioResultResponse) {
        this._data = d;

        if (d.orderTotalDTOList && d.orderTotalDTOList.length) {
            this.ordersSummary = d.orderTotalDTOList.filter(x => x.quantity >= 0);
            this.taxInfoSummary = d.orderTotalDTOList.filter(x => x.quantity < 0);
        }
    }

    editPortfolio(options?: Object) {
        this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO,
            {...{data: this.data, slot: 'B'}, ...(options || {})});
    }

    editPortfolioById(rebalId: number) {
        this.router.navigate(["/rebalancing/result-summary/", rebalId], {
            relativeTo: this.route,
            queryParams: {portfolio: this.data.portfolioId, previousRebalId: this.data.rebalId},
        }).then(() => {
            this.as.fireEvent(IrbRebalanceEvents.SHOW_PORTFOLIO_RESULT_DETAIL, {
                fullscreen: true,
                request: {
                    method: "getDetails",
                    rebalId: rebalId,
                    portfolioId: this.data.portfolioId,
                    secListLoadReqd: true
                }
            });
        });
    }

    editModel(options?: Object) {
        this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL,
            {
                ...{
                    modelId: this.data.modelId,
                    type: this.data.modelType,
                    modelMarketId: this.data.modelMarketId,
                    isDraft: false,
                    slot: 'B'
                }, ...(options || {})
            });
    }

    hasUserEdits(): boolean {
        return this.pros.hasUserEdits;
    }

    hasOrders(): boolean {
        return this.pros.hasOrders;
    }
}
